import React from 'react'
import numbro from 'numbro'
import Metric from '../Metric'

const Raised = ({
  amountColor,
  format,
  fundraisingPage,
  icon,
  iconColor,
  iconSize,
  label,
  labelColor,
  offset,
  multiplier,
  numberStyle
}) => {
  const amount = fundraisingPage.raised * (multiplier || 1) + (offset || 0)

  return (
    <Metric
      amount={numbro(amount).formatCurrency(format || '0,0')}
      amountColor={amountColor}
      icon={icon}
      iconSize={iconSize || 'small'}
      labelColor={iconColor}
      numberStyle={numberStyle}
      label={label}
    />
  )
}

export default Raised
